import { IAwardInfo, IUserStats } from "@/props/IDonation";
import { useTranslation } from "next-i18next";
import DonationInfo from "./DonationInfo";
import Certificate from "./Certificate";
import { useState } from "react";
import CertificateDownloadModal from "./CertificateDownloadModal";
import { saveAward } from "@/api/donation";

const ClientEventEndContent = ({
  isMobile,
  userStats,
  awardInfo,
}: {
  isMobile: boolean;
  userStats: IUserStats;
  awardInfo: IAwardInfo;
}) => {
  const { t } = useTranslation();
  const [downloadModalOpen, setDownloadModalOpen] = useState<boolean>(false);

  const handleClickDownload = async (params) => {
    await saveAward(params);
    setDownloadModalOpen(false);
  };

  return (
    <div className={`m-auto max-w-[1440px] py-10 text-center text-stone-800 ${isMobile ? "mx-4" : "w-full"}`}>
      <h3 className={`font-semibold ${isMobile ? "mb-4 text-2xl" : "mb-20 h-[60px] text-5xl"}`}>
        {t("csr.end_title")}
        <span className={`${isMobile ? "block" : ""}`}>&nbsp;{t("csr.end_title_2")}</span>
      </h3>
      <div className={`items-stretch ${isMobile ? "flex flex-col" : "flex flex-row"}`}>
        <div className={`flex flex-1 flex-col ${isMobile ? "mb-6" : "mr-6"}`}>
          <div className="mb-9">{t("csr.end_desc")}</div>
          <div className="flex-1">
            <DonationInfo isIB={false} isMobile={isMobile} userStats={userStats} fromEventEnd={true} />
          </div>
        </div>
        <div className="relative flex flex-shrink-0 overflow-hidden rounded-xl">
          <Certificate userStats={userStats} awardInfo={awardInfo} />
          <div
            className={`absolute bottom-0 flex  w-full items-end justify-center 
            ${isMobile ? "h-[140px]" : "h-[320px]"}`}
            style={{
              background: "linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.4) 100%)",
              backdropFilter: "blur(5px)",
            }}
          >
            <button
              className="mb-10 h-[56px] w-[320px] rounded-lg bg-primary font-semibold text-white shadow-md"
              onClick={() => {
                setDownloadModalOpen(true);
              }}
            >
              {t("csr.download_certificate")}
            </button>
          </div>
        </div>
      </div>
      <CertificateDownloadModal
        userStats={userStats}
        open={downloadModalOpen}
        awardInfo={awardInfo}
        onModalCancel={() => {
          setDownloadModalOpen(false);
        }}
        onClickDownload={(params) => {
          handleClickDownload(params);
        }}
      />
    </div>
  );
};
export default ClientEventEndContent;
